import { render, staticRenderFns } from "./HmiComponenteEstadoBarrera.vue?vue&type=template&id=52fa6e6a"
import script from "./HmiComponenteEstadoBarrera.vue?vue&type=script&lang=js"
export * from "./HmiComponenteEstadoBarrera.vue?vue&type=script&lang=js"
import style0 from "./HmiComponenteEstadoBarrera.vue?vue&type=style&index=0&id=52fa6e6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports